// extracted by mini-css-extract-plugin
export default {"disclaimer":"h_2"};